const gdPortfolioList = [
  {
    title: "We Tutor",
    description: "weTutor | Branding | Graphic & Web Design | Logo Design.",
    image: require("../../images/Kuber.png"),
    tools: ["AWS", "Node.js", "MySQL", "React", "SCSS", "Bootstrap"],
    github: "https://github.com/cheyennethreadgill/employee-management-app",
    demo: "https://kubermanagement.netlify.app/",
  },
  {
    title: "Essence",
    description: "Essence|Motion Graphics | 3D Animation | Graphic Design",
    image: require("../../images/krp-gym.png"),
    tools: ["Node.js", "MySQL", "React", "SCSS", "Bootstrap"],
    github: "https://github.com/cheyennethreadgill/kropp-gym",
    demo: "https://kropp-gym.netlify.app",
  },
];

export default gdPortfolioList;
